import React, { useState, useEffect } from "react";

//Components imports
import NavigationBar from "../../components/common/NavigationBar";
import InputField from "../../components/common/InputField";
import SelectElement from "../../components/common/SelectElement";

// Icons imports
import SendButton from "../../components/common/Button";

// Scss imports
import css from "./AddArchive.module.scss";

// redux imports
import { getCertainCategoryPaperNumber } from "../../redux/actions/papersActions";

// redux
import { useSelector, useDispatch } from "react-redux";

import { addArchiveManually } from "../../redux/actions/archiveActions";

interface AddArchiveProps {}

const AddArchive: React.FC<AddArchiveProps> = () => {
  // All categories
  const categories = useSelector(
    (state: any) => state.allCategories.categoriesActive
  );
  const dispatch = useDispatch();
  const [numberOfPapers, setNumberOfPapers] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [papersFrom, setPapersFrom] = useState("");
  const [papersTo, setPapersTo] = useState("");
  const [shortText, setShortText] = useState("");
  const [shelfLifeTo, setShelfLifeTo] = useState<any>("");
  const [remark, setRemark] = useState("");
  const [subnumbers, setSubnumbers] = useState<any>("");
  const [categoryListArray, setCategoryListArray] = useState([
    { value: "", name: "Изабери", categoryNumber: "" },
  ]);
  const [disabledButton, setDisabledButton] = useState(true);
  // State for selected category, depeends on this category give basic number
  const [category, setCategory] = useState(categoryListArray[0].value);
  const [form, setForm] = useState({});
  const [baseNumberId, setBaseNumberId] = useState("");

  const categoriesArray = categories.data;
  const [baseNumber, setBaseNumber] = useState(
    categoryListArray[0].categoryNumber
  );
  const [baseNumberShelfLife, setBaseNumberShelfLife] = useState<any>("");
  const [subnumbersArray, setSubnumbersArray] = useState([]);

  // From categories array get array for showing categories
  const catArr =
    categoriesArray && categoriesArray.length > 0
      ? categoriesArray.map((element) => {
          return {
            value: element._id,
            name: element.name,
            categoryNumber: element.baseNumber,
            shelfLife: element.shelfLife,
          };
        })
      : [];

  const handleChange = (e, setValue): void => {
    setValue(e.target.value);
  };

  // On change category select
  const onSelectChange = (e) => {
    setCategory(e.target.value);

    // Filter array and return object from choosen selected option
    let selectedObject: any = categoryListArray.filter((obj) => {
      return obj.value === e.target.value;
    });

    setBaseNumber(selectedObject[0].categoryNumber);
    setBaseNumberId(selectedObject[0].value);
    setBaseNumberShelfLife(selectedObject[0].shelfLife);
    console.log(selectedObject[0]);
    //setSubnumber(selectedObject[0].categoryNumber + 1);
    dispatch(getCertainCategoryPaperNumber(selectedObject[0].value));
  };

  const addArchive = () => {
    console.log(numberOfPapers);
    dispatch(addArchiveManually(form));
    console.log(form);
  };

  useEffect(() => {
    setCategoryListArray([
      { value: "", name: "Изабери", categoryNumber: "" },
      ...catArr,
    ]);

    setForm({
      numberOfPapers: numberOfPapers,
      papersFrom: papersFrom,
      papersTo: papersTo,
      subnumbers: subnumbersArray,
      baseNumber: baseNumberId,
      content: shortText,
      shelfLifeTo: shelfLifeTo,
      remark: remark,
    });
  }, []);

  useEffect(() => {
    setForm({
      numberOfPapers: numberOfPapers,
      papersFrom: papersFrom,
      papersTo: papersTo,
      createdAt: createdAt,
      subnumbers: subnumbersArray,
      baseNumber: baseNumberId,
      content: shortText,
      shelfLifeTo: shelfLifeTo,
      remark: remark,
    });

    if (
      numberOfPapers.length > 0 &&
      papersFrom.length > 0 &&
      papersTo.length > 0 &&
      createdAt.length > 0 &&
      subnumbers.length > 0 &&
      baseNumberId.length > 0 &&
      shortText.length > 0
    ) {
      setDisabledButton(false);
    }

    setShelfLifeTo(
      baseNumberShelfLife === "трајно"
        ? "трајно"
        : baseNumberShelfLife * 1 + new Date(Date.now()).getFullYear()
    );

    const arrNumbers = subnumbers.split(",");
    setSubnumbersArray(arrNumbers);
    console.log(arrNumbers);
  }, [
    numberOfPapers,
    shortText,
    papersFrom,
    papersTo,
    createdAt,
    subnumbers,
    baseNumber,
    shelfLifeTo,
    remark,
    baseNumberId,
    baseNumberShelfLife,
  ]);

  return (
    <div>
      <NavigationBar />
      <h1>Датум архивирања</h1>
      <form className={css.formContainer}>
        <InputField
          label="Креирана дана"
          name="createdAt"
          id="createdAt"
          type="date"
          value={createdAt}
          placeholder=""
          handleChange={(e) => {
            handleChange(e, setCreatedAt);
          }}
          inputType="rowInput"
        />
        <InputField
          label="Документа од"
          name="papersFrom"
          id="papersFrom"
          type="date"
          value={papersFrom}
          placeholder=""
          handleChange={(e) => {
            handleChange(e, setPapersFrom);
          }}
          inputType="rowInput"
        />{" "}
        <InputField
          label="Документа до"
          name="papersTo"
          id="papersTo"
          type="date"
          value={papersTo}
          placeholder=""
          handleChange={(e) => {
            handleChange(e, setPapersTo);
          }}
          inputType="rowInput"
        />
        <div className={css.selectInput}>
          <SelectElement
            label="Основни број"
            id="baseNumber"
            name="baseNumber"
            handleChange={(e) => onSelectChange(e)}
            selectOptionsArray={categoryListArray}
            minLabelWidth={true}
            type="marginTopSelect"
          />
          <InputField
            label="О.б"
            name="baseNumber"
            id="baseNumber"
            type="number"
            value={baseNumber}
            disabled={true}
          />
        </div>
        <InputField
          label="Подбројеви"
          name="subnumbers"
          id="subnumbers"
          type="text"
          value={subnumbers}
          placeholder=""
          handleChange={(e) => {
            handleChange(e, setSubnumbers);
          }}
          inputType="rowInput"
        />
        <InputField
          label="Кратак садржај"
          name="shortText"
          id="shortText"
          type="text"
          value={shortText}
          handleChange={(e: any) => {
            handleChange(e, setShortText);
          }}
          inputType="rowInput"
        />
        <InputField
          label="Количина"
          name="numberOfPapers"
          id="numberOfPapers"
          type="number"
          value={numberOfPapers}
          placeholder=""
          handleChange={(e) => {
            handleChange(e, setNumberOfPapers);
          }}
          inputType="rowInput"
        />
        <InputField
          label="Рок чувања"
          name="shelfLifeTo"
          id="shelfLifeTo"
          type="text"
          value={shelfLifeTo}
          handleChange={(e: any) => {
            handleChange(e, setShelfLifeTo);
          }}
          inputType="rowInput"
        />
        <InputField
          label="Напомена"
          name="remark"
          id="remark"
          type="text"
          value={remark}
          handleChange={(e: any) => handleChange(e, setRemark)}
          inputType="rowInput"
        />
        {/* Send button */}
        <div className={css.sendButtonWrapper}>
          <SendButton
            text="Креирај документ"
            onButtonClickHandler={addArchive}
            disabledButton={disabledButton}
          />
        </div>
      </form>
    </div>
  );
};

export default AddArchive;
